export class Villain {
    public LegendaryVillainId: number = 0;
    public UserName: string = "";
    public Name: string = "";

    public Type: string = "";

    public Limit: number = 0;
    public BecomeHero: boolean = false;
    public BecomeMastermind: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/models/villain.ts